import { useEffect, useState } from "react";

import AddBatchContentPopup from "./AddBatchContentPopup"
import { X } from "lucide-react";

import axios from "axios";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { webUrlNode } from "../../../constants/appInfo";
 export default function BatchLeftPopup({
    setCurrentDripItemStatus,
  currentItem,
  currentDripItem,contentDripArr,   // null = add, object = edit
  
}) {
   
           
            const {batchId} = useParams();
  const [batch, setBatch] = useState(null);
  const [loading, setLoading] = useState(false);
        
        const courseData = useSelector((state)=>state?.course?.course);
  

  const AppToken = useSelector((s)=>s?.app?.app?.AppToken);
      const coursePostId = useSelector((state)=>state?.course?.course?.postId);
        const currentToken = useSelector((state)=>state?.user?.user?.token);
           
  useEffect(() => {
    if (!batchId ) return;
    load();
  }, [batchId]);

  async function load() {
    setLoading(true);
    try {
      const res = await axios.get(`${webUrlNode}/api/batches/${batchId}`, {
       params: {
          appToken:AppToken,
          coursePostId,
          currentToken
          
        }
      });

      setBatch(res.data.item);
    } finally {
      setLoading(false);
    }
  }

 

  if (!batch) return null;

    return(<>
{
   <div className="appDesignPopUp"  style={{zIndex:9999999,} }>
   <div    style={{cursor:"pointer",zIndex:99999999}} onClick={()=>{setCurrentDripItemStatus(false)}}
            className="appDesignPopUpOpacity"></div>
   <div   className="appDesignPopUpInner " style={{margin:'0px',
    overflowY: "auto",zIndex:99999,background:"#f9f9f9",top:"0px"}}>
         { <div style={{width:"30px",height:"30px",cursor:"pointer",position:"fixed",borderRadius:"50%",
    right:"2px",top:"2px",
      background:"#958FDA"}} onClick={()=>{setCurrentDripItemStatus(false)}}><X style={{margin:"6px"}} color="#ffffff" size={18}/></div>}
   
        <div className="userInfoLiner" style={{background:"#ffffff"}} >
        <div className="userInfoLinerInn" style={{background:"#ffffff"}}>
        
            <div className="userInfoLinerName">
        
          <div>
 <h4   >Course: {courseData?.productName} | Batch:({batch.batchName}) </h4> 
          

          

        </div>
          </div>
          </div>  <div className="userInfoLinerInn">
          

          
          </div>
          </div>
          
<AddBatchContentPopup
currentItem={currentItem}
  contentDripArr={contentDripArr}
  currentDripItem={currentDripItem}
  onClose={()=>{setCurrentDripItemStatus(false)}}
  onAdded={()=>{}}
/>
        

        
         </div></div>}</>
)
 }